import { maxSETaxThreshold2024 } from '../constants/values2024';
import { maxSETaxThreshold2025 } from '../constants/values2025';
import { maxSETaxThreshold2026 } from '../constants/values2026';

type maxSETaxThresholds = {
  [key: string]: number;
};

const maxSETaxThresholds: maxSETaxThresholds = {
  '2024': maxSETaxThreshold2024,
  '2025': maxSETaxThreshold2025,
  '2026': maxSETaxThreshold2026,
}

const seTaxFunction = (businessIncome: number, wages: number, taxYear: string): number => {
  const businessIncomeParsed: number = businessIncome;
  const wagesParsed: number = wages;
  const netBusinessIncome = businessIncomeParsed * .9235;
  const maxSETaxThreshold = maxSETaxThresholds[taxYear];
  const wagesLessMaxSETaxThreshold = maxSETaxThreshold - wagesParsed;
  let seTax = 0;
  let addlSETax = 0;

  if (netBusinessIncome < 400) {
    return seTax;
  }

  else if (wagesLessMaxSETaxThreshold <= 0) {
    seTax = netBusinessIncome * .029;
  }
  else if (wagesLessMaxSETaxThreshold > 0) {
    if (netBusinessIncome <= wagesLessMaxSETaxThreshold) {
      seTax = netBusinessIncome * .153;
    }
    else {
      seTax = wagesLessMaxSETaxThreshold * .124;
      addlSETax = netBusinessIncome * .029;
      seTax += addlSETax;
    }
  }
  return Math.round(seTax);
};

export default seTaxFunction;
